<template>
    <div>
        <el-breadcrumb separator=">" class="bread">
            <el-breadcrumb-item :to="{ name: 'advertiseManager' }">广告管理</el-breadcrumb-item>
            <el-breadcrumb-item>修改广告</el-breadcrumb-item>
        </el-breadcrumb>
        <div >
            <el-form  :model="advForm" :rules="advrules" ref="advForm" label-width="150px" class="demo-ruleForm"  v-loading="formloading">
                <el-form-item label="广告名称" prop="advertiseName">
                    <el-input v-model="advForm.advertiseName" placeholder="广告名称" style="width: 60%;" ></el-input>
                </el-form-item>
                <el-form-item label="广告类型" prop="typeName" >
                    <el-select v-model="advForm.typeName" placeholder="类型" @change="getfindtype(true)">
                        <el-option
                                v-for="item in typeList"
                                :label="item.typeName"
                                :value="item.typeId"
                        >
                        </el-option>
                    </el-select>
                    <span v-show="matFlag">&nbsp;&nbsp;&nbsp;&nbsp;广告尺寸：{{advForm.materialW}}*{{advForm.materialH}}</span>
                </el-form-item>

                <el-form-item label="广告类型" prop="fodderW" v-show="false">
                    <el-select v-model="advForm.fodderW" placeholder="类型" @change="getfindtype('')">
                        <el-option
                                v-for="item in typeList"
                                :label="item.fodderW"
                                :value="item.typeId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="广告类型" prop="fodderW" v-show="false">
                    <el-select v-model="advForm.fodderH" placeholder="类型" @change="getfindtype('')">
                        <el-option
                                v-for="item in typeList"
                                :label="item.fodderH"
                                :value="item.typeId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="fileList">
                    <el-upload class="upload-demo" ref="upload" :action="uploadurl" :data="upload_data" :on-preview="handlePreview"
                               :on-remove="handleRemove" :limit="3" :on-success="handleSuccess" :before-upload="handletype"
                               :file-list="advForm.fileList">
            <span v-bind:class="{isable:isorno}">
                <el-button size="small" type="success">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">大小不超过100MB</div>
            </span>
                    </el-upload>
                </el-form-item>

                <!--<el-form-item label="跳转类型" prop="targetType"  v-if="advForm.pageType === 'float'" >-->
                <el-form-item label="跳转类型" prop="targetType" v-if="typeFlag">
                    <el-select v-model="advForm.targetType" placeholder="跳转目标类型" @change="istargetType()" >
                        <el-option value="0" label="无">无</el-option>
                        <el-option value="1" label="商品">商品</el-option>
                        <el-option value="2" label="品类">品类</el-option>
                        <!--<el-option value="3" label="第三方页面">第三方页面</el-option>-->
                    </el-select>
                </el-form-item>

                <el-form-item prop="hrefList" v-show='advForm.targetType ==="4" && advForm.pageType === "float"' >
                    <el-upload class="upload-demo" ref="uploadHref" :action="uploadurl" :data="upload_data" :on-preview="handlePreview"
                               :on-remove="handleRemoveHref" :limit="3" :on-success="hrefSuccess" :before-upload="hrefType"
                               :file-list="advForm.hrefList">
            <span v-bind:class="{isable:isornohref}">
              <el-button size="small" type="success">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">大小不超过100MB</div>
            </span>
                    </el-upload>
                </el-form-item>

                <el-form-item label="跳转目标" prop="href" v-show="ishref">
                    <el-input v-model="advForm.href" placeholder="跳转目标" style="width: 30%;"></el-input>
                </el-form-item>

                <el-form-item label="跳转目标" prop="goodsList" v-show="isgoods">
                    <el-select v-model="advForm.ID" placeholder="跳转目标" >
                        <el-option
                                v-for="item in goodsList"
                                :label="item.productName"
                                :value="item.productId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="跳转目标" prop="classifyList" v-show="isclassify">
                    <el-select v-model="ID" placeholder="分类">
                        <el-option
                                v-for="item in classifyList"
                                :label="item.categoryName"
                                :value="item.categoryId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <video id="video" style="width: 200px;height: 200px;" :src="videoFile" v-show="false"></video>


                <el-form-item>
                    <el-button type="primary"  @click="submitForm('advForm')" :disabled="isDisabled">确 定</el-button>
                </el-form-item>


                <el-form-item label="广告名称" prop="advName" v-show="false">
                    <el-input v-model="advForm.advName" placeholder="机构名称" style="width: 60%;" ></el-input>
                </el-form-item>

                <el-form-item label="id" prop="advertiseId" v-show="false">
                    <el-input v-model="advForm.advertiseId" placeholder="id" style="width: 60%;" ></el-input>
                </el-form-item>

                <el-form-item label="图片" prop="imgUrl" v-show="false">
                    <el-input v-model="advForm.imgUrl" placeholder="imgUrl" style="width: 60%;" ></el-input>
                </el-form-item>

                <el-form-item label="视频" prop="videoUrl" v-show="false">
                    <el-input v-model="advForm.videoUrl" placeholder="videoUrl" style="width: 60%;" ></el-input>
                </el-form-item>

                <el-form-item label="视频" prop="audioUrl" v-show="false">
                    <el-input v-model="advForm.audioUrl" placeholder="audioUrl" style="width: 60%;" ></el-input>
                </el-form-item>

            </el-form>

        </div>
    </div>
</template>
<script>
//    import { product ,category } from '@/assets/api.js'

    export  default{

        data(){
            var validateadvName = (rule, value, callback) => {
                this.$http.post(this.adserver+"/advertise/validationAdvName",{advertiseName:value,Token: this.fusionToken}).then(response => {
                    if (response.status === 200) {
                        if (this.advForm.advName != value){
                            if (response.body.code === "200"){
                                callback();
                            }else if(response.body.code === '501') {
                                this.$message({showClose: true, message: data.msg , type: 'error'});
                            }else{
                                callback(new Error('广告名称已存在请重新输入！'));
                            }
                        }else {
                            callback();
                        }
                    }
                },function(response){
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            };
            return{
                formloading: false,
                url:this.adserver+"/advertise/updateAdvertise",
                uploadurl:this.uploadHost+"/advertise/UplodFile",
                isorno:false,
                isornohref: false,
                isDisabled:false,
                matFlag:false,
                typeFlag:false,
                ishref:false,
                isgoods:false,
                isclassify:false,
                resourceType:"",
                labelposition:"left",
                videoFile:'',
                upload_data:{
                    type:this.apkUploadWay,
                    folder:"app"
                },
                ID:'',
                advForm:{
                    ID:'',
                    advertiseName:'',
                    advertiseId:'',
                    targetType:'',
                    advName:'',
                    typeName:'',
                    fileList:[],
                    hrefList: [],
                    fodderH:'',
                    fodderW:'',
                    materialW:'0',
                    materialH:'0',
                    href:'',
                    Name:"",
                    ParentID:"",
                    pageType: ''
                },
                takeawayType: ['eleme'],
                typeList:[],
                goodsList:[],
                classifyList:[],
                categoryList:[],
                isorginit:'1',
                advrules: {
                    advertiseName: [
                        { required: true, message: '请输入广告名称', trigger: 'blur' },
                        { validator: validateadvName, trigger: 'blur' },
                        { min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' }
                    ],
                    typeName: [
                        { required: true, message: '请选择广告类型', trigger: 'change' }
                    ],
                    /*fileList: [
                        { validator: validateFileList, trigger: 'change' },
                    ],*/
                },
                fusionToken:'',
            }
        },
        created(){
            this.initData();
            this.getfindtype(false);
            this.getBranch();
        },
        methods:{
            getBranch(){
                this.$http.get(this.deviceHost+"/vueFeign/findBranchs?tenantId="+this.getcookie('storeId')+"&Token="+this.token)
                    .then(response => {
                        if (response.body.Code === '200') {
                            this.fusionToken = response.body.Data.branchs[0].fusionToken;
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            submitForm(formName) {
                console.log('this.takeawayType',this.takeawayType)
                this.formloading = true
                let hrefType = "";
                let targetType = this.advForm.targetType
                if(!this.advForm.advertiseName){
                    this.$message({showClose: true,message: '请输入广告名称',type: 'error'});
                    this.formloading = false
                    return false;
                }
                if(!(this.advForm.imgUrl || this.advForm.videoUrl || this.advForm.audioUrl)){
                    this.$message({showClose: true,message: '请先上传文件',type: 'error'});
                    this.formloading = false
                    return false;
                }
                var typeUrl = "";
                var typeFlag = false;
                var params={
                }
                if(targetType == "1"){
                    hrefType = "product:"+this.advForm.ID;
                    typeUrl = this.productURL+"/vueFeign/findProCorrelation";
                    typeFlag = true;
                    params={
                        tenantId: this.getcookie('storeId'),
                        productId: this.advForm.ID,
                    }
                }
                if(targetType == "2"){
                    hrefType = "classx:"+this.ID
                    typeUrl = this.productURL+"/vueFeign/findClassCorrelation";
                    typeFlag = true;
                    params={
                        tenantId: this.getcookie('storeId'),
                        classId: this.ID,
                    }
                }
                if(targetType == "3"){
                    hrefType = this.advForm.href;
                    typeFlag = false;
                }
                if(targetType == ""){
                    this.$message({showClose: true,message: '请选择跳转目标',type: 'error'});
                    this.formloading = false
                    return false;
                }
                if(targetType == "4"){
                    if(this.advForm.href){
                        hrefType = this.advForm.href;
                    }else{
                        this.$message({showClose: true,message: '请选择跳转目标',type: 'error'});
                        this.formloading = false
                        return false;
                    }
                }else if(this.advForm.pageType === 'button' || this.advForm.pageType === 'buttonRight' || this.advForm.pageType === 'buttonMiddle'){
                    if(!targetType){
                        this.$message({showClose: true,message: '请选择跳转目标',type: 'error'});
                        this.formloading = false
                        return false;
                    }else {
                        hrefType = targetType;
                    }
                    if((!this.takeawayType || this.takeawayType.length == 0) && this.advForm.targetType === '7'){
                        this.$message({showClose: true,message: '请至少选择一种外卖种类',type: 'error'});
                        this.formloading = false
                        return false;
                    }else if(this.advForm.targetType === '7') {
                        let awayTypeList = this.takeawayType
                        for(let awayIndex = 0; awayIndex<awayTypeList.length; awayIndex++){
                            hrefType = hrefType + '_' + awayTypeList[awayIndex]
                        }
                    }
                }
                if(typeFlag){
                    this.$http.post(typeUrl,params).then((response)=>{
                        var data=response.body;
                        if(data.Code=="200") {
                            var pro = "";
                            if(targetType == "1"){
                                var pro = "product:"+JSON.stringify(data.Data)+""
                            }else if(targetType == "2"){
                                var pro = "classx:"+JSON.stringify(data.Data)+""
                            }

                            this.saveAdv(pro);
                        }else{
                            this.$message({showClose: true,message: '参数错误',type: 'error'});
                        }
                    },()=>{
                        this.formloading = false
                        this.$message({showClose: true,message: '网络异常',type: 'error'});
                    })
                }else {
                    this.saveAdv(hrefType);
                }
            },
            saveAdv(hrefType){
                var params={
                    advertiseName: this.advForm.advertiseName,
                    advertiseId: this.advForm.advertiseId,
                    typeId: this.advForm.typeName,
                    imgUrl: this.advForm.imgUrl,
                    videoUrl: this.advForm.videoUrl,
                    audioUrl: this.advForm.audioUrl,
                    href: hrefType,
                    Token: this.fusionToken
                }
                this.$http.post(this.url,params).then((response)=>{
                    var data=response.body;
                    if(data.code=="200") {
                        this.formloading = false
                        this.$message({showClose: true, message: '保存成功', type: 'success'});
                        this.$router.push({path: "advertiseManager"})
                    }else if(data.code=="501"){
                        this.formloading = false
                        this.$message({showClose: true,message: data.msg ,type: 'error'});
                    }else{
                        this.formloading = false
                        this.$message({showClose: true,message: '参数错误',type: 'error'});
                    }
                },()=>{
                    this.formloading = false
                    this.$message({showClose: true,message: '网络异常',type: 'error'});
                })
            },
            handletype(file) {
                if(this.advForm.typeName == "" || this.advForm.typeName == null){
                    this.$message({showClose: true, message: '请选择广告类型', type: 'error'});
                    return false;
                }else {
                    var obj = this.typeList.find((item) => {//这里的userList就是上面遍历的数据源
                        return item.typeId == this.advForm.typeName;//筛选出匹配数据
                    });
                    if(type !== "mp3"){
                        this.advForm.fodderW = obj.fodderW
                        this.advForm.fodderH = obj.fodderH
                    }

                    var n = file.name.split(".");
                    var len = n.length;
                    var type = n[len - 1];

                    if (type !== "mp3" && type !== "mp4" && type !== "jpg" && type !== "png" && type !== "gif") {
                        this.$message({showClose: true, message: '只能选择mp4或者图片文件', type: 'error'});
                        this.clear("upload");
                        return false;
                    } else {
                        var _this = this;
                        //判断图片尺寸
                        if (type == "jpg" || type == "png" || type == "gif") {
                            let reader = new FileReader();
                            reader.onload = function (e) {
                                let data = e.target.result;
                                let img = new Image();
                                img.src = data;
                                img.onload = function () {
                                    console.log(img.width+"======"+img.height)
                                    if (img.width == _this.advForm.fodderW && img.height == _this.advForm.fodderH) {

                                        return true;
                                    } else {
                                        _this.advForm.fileList = [];
                                        _this.$message({
                                            showClose: true,
                                            message: '图片尺寸不能大小于' + _this.advForm.fodderW + '*' + _this.advForm.fodderH,
                                            type: 'error'
                                        });
                                        _this.clear("upload");
                                        _this.isorno = false;
                                        return false;
                                    }
                                    ;
                                }
                            }
                            reader.readAsDataURL(file)
                        } else if(type == "mp4"){
                            //视频尺寸
                            console.log(file);
                            var url = URL.createObjectURL(file);
                            this.videoFile = url;
                            var videofile = document.getElementById("video");
                            videofile.addEventListener("progress", function (e) {
                                if(videofile.videoWidth != '0'){
                                    if (videofile.videoWidth == _this.advForm.fodderW && videofile.videoHeight == _this.advForm.fodderH) {
                                        return true;
                                    } else {
                                        _this.advForm.fileList = [];
                                        _this.$message({
                                            showClose: true,
                                            message: '视频尺寸不能大小于' + _this.advForm.fodderW + '*' + _this.advForm.fodderH,
                                            type: 'error'
                                        });
                                        _this.clear("upload");
                                        _this.isorno = false;
                                        return false;
                                    }
                                }
                            });
                        }else if(type == "mp3"){
                            return true;
                        }
                    }
                    if (this.advForm.fileList.length >= 0) {
                        this.isorno = true;
                    }
                    ;
                }
            },
            hrefType(file) {
                if(this.advForm.typeName === "" || this.advForm.typeName === null){
                    this.$message({showClose: true, message: '请选择广告类型', type: 'error'});
                    return false;
                }else{
                    var _this = this;
                    var n = file.name.split(".");
                    var len =n.length;
                    var type = n[len-1];

                    if (type !== "jpg" && type !== "png" && type !== "gif" && type !== "jpeg") {
                        this.$message({showClose: true, message: '只能选择图片文件', type: 'error'});
                        this.clear("uploadHref");
                        return false;
                    }
                    if (this.advForm.hrefList.length >= 0) {
                        this.isornohref = true;
                    }
                }
            },
            handleRemove(file, fileList) {
                this.isorno=false;
                this.advForm.fileList = fileList;
            },
            handleRemoveHref(file, fileList) {
                this.isornohref=false;
                this.advForm.hrefList = fileList;
            },
            handlePreview(file) {
            },
            handleSuccess(response, file, fileList){
                this.advForm.fileList = fileList;
                this.filepath = response.path;

                var n = file.name.split(".");
                var len =n.length;
                var type = n[len-1];

                if (type =="mp4"){
                    this.advForm.imgUrl = '';
                    this.advForm.audioUrl = '';
                    this.advForm.videoUrl = this.filepath;
                }else if(type =="mp3"){
                    this.advForm.videoUrl = '';
                    this.advForm.imgUrl = '';
                    this.advForm.audioUrl = this.filepath;
                }else {
                    this.advForm.imgUrl = this.filepath;
                    this.advForm.videoUrl = '';
                    this.advForm.audioUrl = '';
                }
            },
            hrefSuccess(response, file, fileList){
                if(response.code === '200'){
                    this.advForm.href = response.path;
                }else{
                    this.$message({showClose: true, message: '上传失败，请重试', type: 'error'});
                }
            },
            submitUpload(fileList) {
                this.$refs.upload.submit();
            },
            getfindtype(flag){
                this.istargetType();
                this.$http.get(this.adserver+"/advertise/advertiseType?Token="+this.fusionToken).then((response)=>{
                    if(flag){
                        this.advForm.fileList = [];
//                        this.advForm.targetType = ''
                        this.advForm.imgUrl = "" ;
                        this.advForm.videoUrl = "";
                        this.advForm.audioUrl = "";
                        this.isorno = false;
                        this.matFlag = false;
                        this.clear("upload");
                        this.clear("uploadHref");
                    }
                    this.advForm.fodderH = this.advForm.typeName;
                    this.advForm.fodderW = this.advForm.typeName;
                    if(this.advForm.typeName != "" && this.advForm.typeName != null){
                        this.matFlag = true;
                    }
                    if(response.body.code === "200"){
                        this.typeList  = response.body.typeList;
                        for (var i=0;i<this.typeList.length;i++){
                            if(this.typeList[i].typeId == this.advForm.fodderH){
                                this.advForm.materialW = this.typeList[i].fodderW;
                                this.advForm.materialH = this.typeList[i].fodderH;
                                this.advForm.pageType = this.typeList[i].pageType;
                            }
                        }
                    }else {
                        this.$message({showClose: true,message: response.body.msg ,type: 'error'});
                    }
                },()=>{
                    this.$message({showClose: true,message: '网络异常',type: 'error'});
                })

            },
            initData(){
                var advInfo = this.$route.query.data;
                console.log('data',advInfo)
                this.advForm.advertiseName = advInfo.advertiseName;
                this.advForm.advertiseId = advInfo.advertiseId;
                this.advForm.id = advInfo.id;
                //var href = advInfo.href.slice(0,2);
                this.advForm.typeName = advInfo.typeId;
                this.advForm.advName = advInfo.advertiseName;
                this.advForm.pageType = advInfo.pageType;
                if(advInfo.href != '' && advInfo.href != null){
                    var a = advInfo.href.split(":");
                    if(a[0] == 'product'){
                        this.advForm.targetType = '1';
                        this.ishref = false;
                        this.isclassify = false;
                        this.isgoods = true;
                        this.getfindPro(a[1]);
                        this.getProductList();
                    }else if(a[0] == 'class'){
                        this.advForm.targetType = '2';
                        this.isgoods = false;
                        this.ishref = false;
                        this.isclassify = true;
                        this.getfindClass(a[1]);
                        this.getCategoryList();
                    }else {
                        this.advForm.targetType = '0';
                        this.advForm.href = '';
                        this.isclassify = false;
                        this.isgoods = false;
                        this.ishref = false;
                    }
                }else {
                    this.advForm.targetType = '0';
                }

                this.advForm.imgUrl = advInfo.imgUrl;
                this.advForm.videoUrl = advInfo.videoUrl;
                this.advForm.audioUrl = advInfo.audioUrl;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            clear(name) {
                this.$refs[name].clearFiles();
            },
            istargetType(){

                let targetType = this.advForm.targetType
                let typeName = this.advForm.typeName
                if(typeName == 'type20190203425123' || typeName == 'type20190521521044' || typeName == 'type20190522430422' || typeName == 'type20190523255333' ||
                    typeName == 'type20190524301514' || typeName == 'type20190524552403' || typeName == 'type20190524252152' || typeName == ''){
                    this.typeFlag = false;
                    this.advForm.targetType = '0';
                }else {

                    this.typeFlag = true;
                }
                if(targetType == "1"){
                    this.ishref = false;
                    this.isclassify = false;
                    this.getProductList();
                    this.isgoods = true;
                }else if (targetType == "2"){
                    this.isgoods = false;
                    this.ishref = false;
                    this.isclassify = true;
                    this.getCategoryList();
                }else if(targetType == "3"){
                    this.isgoods = false;
                    this.isclassify = false;
                    this.ishref = true;
                }else {
                    this.isclassify = false;
                    this.isgoods = false;
                    this.ishref = false;
                }
            },
            getfindPro(id){
                var params = {productId:id};
                this.$http.get(this.productURL+"/vueFeign/getfindPro",{params:params}
                ).then(response => {
                    if (response.status === 200) {
                        if(response.body.Code=='200'){
                            this.advForm.ID = response.body.Data[0];
                        }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                    }
                },function(response){

                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            },
            getfindClass(id){
                var params = {classId:id};
                this.$http.get(this.productURL+"/vueFeign/getfindClass",{params:params}
                ).then(response => {
                    if (response.status === 200) {
                        var li = response.data.Data
                        if(response.body.Code=='200'){
                            this.ID = response.body.Data[0];
                        }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                    }
                },function(response){
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            },
            getProductList(){
                var params = {tenantId:this.getcookie('storeId'),Status:"1",cateID:"",proName:""};
                this.$http.get(this.productURL+"/vueFeign/product",{params:params}
                ).then(response => {
                    if (response.status === 200) {
                        var li = response.data.Data
                        if(response.body.Code=='500') {
                            this.goodsList = []
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else if(response.body.Code=='501'){
                            this.goodsList = []
                            this.$message({showClose: true, message: response.body.msg, type: 'error'});
                        }else if(response.body.Code=='200'){
                            debugger
                            this.goodsList = li;
                            this.$message.success('数据获取成功！')
                        }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                        this.goodsList = []
                    }
                },function(response){
                    this.goodsList = []
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })

            },
            getCategoryList(){
                var params = {tenantId:this.getcookie('storeId')};
                this.$http.get(this.productURL+"/vueFeign/category",{params:params}
                ).then(res => {
                    if (res.status === 200) {
                        if (res.data.Code === '200') {
                            var li = res.data.Data.Category
                            if(res.body.Code=='500') {
                                this.classifyList = []
                                this.$message({showClose: true, message: res.body.msg, type: 'error'});
                            }else if(res.body.Code=='501'){
                                this.classifyList = []
                                this.$message({showClose: true, message: res.body.msg, type: 'error'});
                            }else if(res.body.Code=='200'){
                                this.classifyList = li;
                                this.$message.success('数据获取成功！')
                            }
                        } else {
                            this.$message.error('数据获取失败，异常：' + res.data.Meta)
                        }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                        this.classifyList = []
                    }
                },function(response){
                    this.items = []
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            },
            setCategoryList(){
//                let category = this.classifyList[this.classifyindex].Children;
//                this.categoryList = category;
//                console.log(category);
            }
        }
    }
</script>
<style>
    .isable{
        display:none;
    }
</style>



// WEBPACK FOOTER //
// AdvertiseModify.vue?9a016c10